var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72912 0 0 6.72912 0 15C0 23.2709 6.72912 30.0001 15 30.0001C23.2709 30.0001 30.0001 23.2709 30.0001 15C30.0001 6.72912 23.2709 0 15 0ZM15.9757 23.8999C15.2631 24.0187 13.8451 24.3154 13.125 24.3751C12.5155 24.4255 11.9403 24.0766 11.5897 23.5758C11.2381 23.075 11.1539 22.4341 11.3626 21.8592L14.198 14.0625H11.25C11.2475 12.438 12.466 11.2434 14.0246 10.785C14.7684 10.5661 16.1541 10.2667 16.875 10.3126C17.3069 10.34 18.0597 10.611 18.4103 11.1118C18.7619 11.6126 18.8461 12.2535 18.6374 12.8285L15.802 20.6251H18.7491C18.7497 22.2478 17.5765 23.6331 15.9757 23.8999ZM16.875 9.37503C15.8394 9.37503 15 8.53547 15 7.50001C15 6.46445 15.8394 5.625 16.875 5.625C17.9106 5.625 18.75 6.46445 18.75 7.50001C18.75 8.53552 17.9106 9.37503 16.875 9.37503Z",
    fill: "#BBC2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.cf00b0165b4bd140f12f45bfdb8438df.svg";
export { ForwardRef as ReactComponent };